/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import './index.css';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import Rating from '@mui/material/Rating';
import WriteReview from './WriteReviews';
import Loader from '../Loader';
import Header from '../Header';
import ReviewComponent from './QrReviewComponent';

function MainContainer({ baseURL }) {
  const [page, setPage] = useState(1);
  const [getData, setGetData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    GetDataApi();
  }, []);

  const GetDataApi = async () => {
    setLoading(true);
    const response = await axios.get(`${baseURL}/company/get-review-links/${id}`,{
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',         
      },
    });
    if (response.data.status === 'success') {
      setGetData(response?.data?.data);
      setLoading(false);
    }
    const body = {
      type: 'scanned',
      qr_type: 'review',
    };
    if (localStorage.getItem('scanned') === null) {
      const res = await axios.put(`${baseURL}/company/update-qr-code/${id}`,body);
    }
    localStorage.setItem('scanned', 'true');
  };

  const handleReviewActivity = async (value,type) => {
    // console.log('value',value);
    const body = {
      type: 'clicked',
      qr_type: 'review',
    };
    if (localStorage.getItem('clicked') === null) {
      const res = await axios.put(`${baseURL}/company/update-qr-code/${id}`,body);
      localStorage.setItem('clicked', 'true');
    }
    if (type === 'facebook_type' && getData?.template?.review_site_1_platform === 'Google') {
      window.open(value, '_self');
    }
    if (type === 'google_type' && getData?.template?.review_site_2_platform === 'Facebook') {
      window.open(value, '_self');
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="qs-page">
      <div className="qs-card min-h-[500px]">
        <Header 
          logo={getData?.company_logo}
          headerColor={getData?.display?.email_header_color}
          headerTextColor={getData?.display?.email_header_text_color}
          companyName={getData?.name}
          ratingValue={(getData?.rating_average === null ? null : Number(Math.round((getData?.rating_average) * 10) / 10))}
          reviewCount={getData?.review_count}
        />

        <div className="qs-card-body flex-1">
          {page === 1 && (
          <ReviewComponent 
            getData={getData} 
            handleReviewActivity={handleReviewActivity} 
            setPage={setPage}
            page={page}
          />
          )}
        </div>
      </div>
    </div>
  );
}

export default MainContainer;
